import React, { useEffect, useState } from 'react';
import Wrapper from '../../components/Wrapper/Wrapper';
import { withRouter} from 'react-router-dom';
import { connect } from "react-redux";
import * as logger from "../../../logger";
import {
    getSubscriptionStatus,
    getPaymentLink
  } from "../../../store/actions/paymentsActionCreator";
import { makeStyles, 
  Typography, 
  Paper,
  Button
} from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    infoCard: {
      width: '100%',
      height: 56,
      padding: "19px 16px",
      display: 'flex',
      alignItems: 'center',
    },
    infoCardTitle: {
      color: '#6b778c',
      fontSize: 12,
      textTransform: 'uppercase',
      fontWeight: 600,
      letterSpacing: 'normal'
    },
    infoCardIcon: {
      fontSize: 14,
      margin: '-2px 3px 0px 3px',
      color: '#A8A8A8',
      //float: 'right',
      cursor: 'pointer'
      // marginTop: 4
    },
    value: {
      fontSize: 22,
      textTransform: 'uppercase',
      fontWeight: 300,
      textAlign: 'right'
      //float:'right'
    },
    first: {
      //width:'100%'
    },
    last: {
      //width:'70%'
      marginLeft: '1em'
    }
  }));
const SubscriptionStatus = ({ payments, dispatchGetSubscriptionStatusAction,dispatchGetSubscriptionPaymentLinkAction}) => {
    const classes = useStyles();
    useEffect(() => dispatchGetSubscriptionStatusAction((data)=>{
      if (data.status && data.status.code == 200) {

      }
    }), [
        dispatchGetSubscriptionStatusAction
      ]);
      const makePayment = (paymentOption) => {
        if (payments && payments.subscriptionStatus 
          && payments.subscriptionStatus.status 
          && payments.subscriptionStatus.subscriptionType
          && payments.subscriptionStatus.orderId
          && payments.subscriptionStatus.status=="PROCESSING"
          && payments.subscriptionStatus.subscriptionType =="PAID"){
            dispatchGetSubscriptionPaymentLinkAction(
              payments.subscriptionStatus.orderId,
              (data) => {
                if (data && data.status && data.status.code == 200 && data.response && data.response.paymentLink) {
                  window.location.href = data.response.paymentLink;
                }
              },
              () => { },
          )
      }
       
    };
    return (
    <>
       {payments.subscriptionStatus && <Paper className={classes.infoCard} >
        <div className={classes.first}>
          <Typography variant="subtitle2" className={classes.infoCardTitle}>
            {payments.subscriptionStatus.status}
          </Typography>
          <Button variant="contained" onClick={(e)=>{makePayment()}} color="primary">
                                Make Payment
          </Button>
        </div>
        {/* <div className={classes.last}>
          <Typography variant="subtitle2" className={classes.infoCardSecondTitle}>
            {title1}
          </Typography>
          <Typography variant="subtitle2" className={classes.value} style={{ color: color1 ? color1 : 'inherit' }}>
            {value1}
          </Typography>
        </div> */}
      </Paper>}
    </>
  );

};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSubscriptionStatusAction: (onSuccess, onFailure) => {
        dispatch(getSubscriptionStatus(onSuccess, onFailure))
    },
    dispatchGetSubscriptionPaymentLinkAction: (id,onSuccess, onFailure) => {
      dispatch(getPaymentLink(id,onSuccess, onFailure))
    }
});
const SubscriptionStatusWithRouter = withRouter(SubscriptionStatus);
export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(SubscriptionStatusWithRouter);
